import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { isPlatformOnlySuperAdmin } from '../../utils/platformAdmin';

interface SalonScopedRouteProps {
  children: React.ReactNode;
}

/** Blocks platform super admins from salon CRM routes until they impersonate a tenant user. */
const SalonScopedRoute: React.FC<SalonScopedRouteProps> = ({ children }) => {
  const { user } = useAppSelector((state) => state.auth);

  if (isPlatformOnlySuperAdmin(user)) {
    return <Navigate to="/super-admin" replace />;
  }

  return <>{children}</>;
};

export default SalonScopedRoute;
